import BaseService from './BaseClassicService';

export default class UserService extends BaseService {
    adaptation(data) {
        return data.map((item) => ({
            id: item.user_id,
            name: item.user_struct_name,
            dept_id: item.dept_id,
            company_id: item.company_id,
            dept_name: item.dept_name,
            login: item.user_name,
            post_name: item.user_post_name,
            shortname: item.user_shortname,
            fullname: item.user_fullname,
            type_name: item.user_type_name,
            is_principal: item.user_is_principal,
            actual: item.user_actual,
            user_admin: item.user_admin
        }));
    }
}